import React from 'react'
import { Link } from 'react-router-dom'
import TimeAgo from 'react-timeago'


class Update5 extends React.Component{



render() {

  return(
  <div>
  <h1 className="introduction-header" >Newforma Enterprise API</h1>
  <p className="introduction-p-italic">
  By Nathan Sellers <TimeAgo date="May 6, 2019" />
  </p>
    <p className="introduction-p"> Newforma Enterprise API has been <span className="orange">Released</span>!</p>
    <p className="introduction-p">
    As a part of our new API product we have released Newforma Enterprise APIs. All things Newforma API related will now fall under our new product
    Newforma Connect. Within Newforma Connect you will find our Project Center APIs as well as our ConstructEx APIs. The Project Center APIs are broken into
    multiple categories, Newforma Enterprise APIs, Web/Mobile APIs and Legacy APIs.
    <br />
    <br />
    The Newforma Enterprise APIs are newly available as a part of Newforma Project Center Server release 12.1.5. Please note that any updates in the future to
    these APIs will in most cases require an upgrade of NPCS. That being said as each new version is released a previously installed version will still be supported
    and functional until it is announced that we are changing major versions.
    <br />
    <br />
    Along with this release of Newforma Enterprise API v1.0 I am happy to announce we have also streamlined our authentication requirements. For more information
    regarding our authentication please visit the Getting-Started section as well as the detailed update page for Authentication.
    <br />
    <br />
    More Info: <Link to="/getting-started">Getting Started page.</Link>
    </p>


    <p className="introduction-p"> We of course will not be stopping here, everyday our Developers are working hard to create more powerful API resources to give
      you access to the information you need. Please visit the Updates page frequently to keep up with the most recent releases.

    </p>


    </div> )
}
}
export default Update5;



/** WEBPACK FOOTER **
 ** ./src/pages/Updates/update5.js
 **/